import { useMemo } from "react";

import { useAppDispatch } from "../../Store/Hooks";
import { createLiveAdapter, type DataHubAdapter } from "../data/adapter";

/** The live Data Hub adapter, bound to this store's dispatch. */
export function useDataHubAdapter(): DataHubAdapter {
  const dispatch = useAppDispatch();
  return useMemo(() => createLiveAdapter(dispatch), [dispatch]);
}
